import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../context/GlobalContext";
import Loader from "../Loader/Loader";
import CheckOrders from "./CheckOrders";
import OrderList from "./OrderList/OrderList";
import OrderStatus from "./OrderStatus";
import TrackOrderError from '../Common/Error/TrackOrderError';
import "./TrackOrders.scss";

function TrackOrders() {
  const [state, dispatch]: any = useContext(GlobalContext);
  const { rtl, currentPage } = state;

  const { t } = useTranslation();

  useEffect(() => {

    if (document.getElementById('mobily_cart_id') !== null) {
      document.getElementById('mobily_cart_id').style.display = 'none';
      document.getElementById('mobily_track_order_id').style.display = 'none';
    }
    dispatch({
      type: "INITIAL_ONLOAD_TRACK_ORDER",
      payload: { page: t("Track_my_order") },
    });
   
  }, [dispatch, t]);
  return (
    <>
      <Loader />
      {currentPage === t("Track_my_order") && <CheckOrders rtl={rtl} />}
      {currentPage === t("Status") && <OrderStatus rtl={rtl} />}
      {currentPage === t("Latest_order_status") && <OrderList rtl={rtl} />}
      {currentPage === t("Trackorder_Error") && <TrackOrderError rtl={rtl} />}
    </>
  );
}

export default TrackOrders;
